module.exports = "pegasus_template/assets/trans-checker.png";